import Vuex from 'vuex'
import router from '../router/index'
import requestService from "@/store/backendRequests"

export default new Vuex.Store({
  state: {
    availableDiskSpace: "",
    isLoggedIn: false,
    snackbar: { active: false, message: ""},
  },
  mutations: {
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar;
    },
    SET_AVAILABLE_DISK_SPACE(state, value) {
      state.availableDiskSpace = value;
    },
    SET_IS_LOGGED_IN(state, value) {
      state.isLoggedIn = value;
    }
  },
  actions: {
    displaySnackbarMessage({ commit }, message) {
      commit("SET_SNACKBAR", {
        active: true,
        message: message,
        timeout: -1
      });
    },

    handleError({ dispatch }, error) {
      let snackbarMessage;
      if (error.response) {
        if (error.response.data.message && error.response.data.code) {
          if (error.response.data.code == 112 || error.response.data.code == 305) {
            dispatch("logout");
            snackbarMessage = "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.";
            router.push("/login");
          } else {
            snackbarMessage = error.response.data.message + " Code: " + error.response.data.code;
          }
        } else {
          snackbarMessage = "unbekannter Fehler";
        }
      } else {
        snackbarMessage = "Der Server konnte nicht erreicht werden.";
      }
      dispatch("displaySnackbarMessage", snackbarMessage);
    },
    getAvailableDiskSpace({commit}) {
      requestService
          .getAvailableDiskSpace()
          .then(
              (response) => {
                if (response.status === 200) {
                  commit('SET_AVAILABLE_DISK_SPACE', response.data.size);
                }
              },
              () => {
                commit('SET_AVAILABLE_DISK_SPACE', "ERROR");
              }
          );
    },
    loggedIn({commit}) {
      commit('SET_IS_LOGGED_IN', true);
    },
    logout({commit}) {
      window.sessionStorage.removeItem('accessToken');
      window.sessionStorage.removeItem('refreshToken');
      commit('SET_IS_LOGGED_IN', false);
    }
  },
  getters: {
    availableDiskSpace: state => {
      return state.availableDiskSpace;
    },
    isLoggedIn: state => {
      if (state.isLoggedIn == true || (window.sessionStorage.getItem('accessToken') != undefined && window.sessionStorage.getItem('accessToken') != null)) {
        return true;
      }
      return false;
    }
  },
  modules: {
  }
})

